export const CLAIM_UTYPE_KEY = 'AEMQ:UserType'
export const CLAIM_UTYPE_USER = 'User'
export const CLAIM_UTYPE_SYSTEMADMIN = 'SystemAdmin'
